// import CoursePlayer from "../../student/Course/CoursePlayer";

import CoursePlayer from "../../student/course/CoursePlayer";
import CourseVideos from "../../student/course/CourseVideos";

export default function Home() {
  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="grid grid-cols-3 gap-2 lg:gap-8">
          <CoursePlayer/>
          <CourseVideos/>
        </div>
      </div>
    </section>
  )
}